import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Section } from '../section';
import { SectionItem } from '../section-item';

const FittingDetails = ({ history, fittingTypes = {} }) => {
  const fittingTypesArray = Object.values(fittingTypes).filter((e) => e);
  return (
    fittingTypesArray.length > 0 && (
      <Section
        analyticsSectionType="fitting type"
        category="Fitting type"
        editPath="/edit-fitting-type"
        history={history}
      >
        {fittingTypesArray.map((fitting, i) => (
          <SectionItem key={`${i}-${fitting}`} title={`Child ${i + 1}:`} definition={fitting} />
        ))}
      </Section>
    )
  );
};

const mapStateToProps = (state) => {
  const {
    appointment: {
      draft: { fittingTypes },
    },
  } = state;
  return {
    fittingTypes,
  };
};

FittingDetails.displayName = 'FittingDetails';

export const ConnectedFittingDetailsWithRouter = withRouter(
  connect(mapStateToProps)(FittingDetails),
);
